/* global moment */
const initializeReskinSelects = require('../util/initialize-reskin-selects');
const { destroyReskinSelect, syncReskinSelect } = initializeReskinSelects;

$(() => {
  const pluginName = 'personalInformationPlugin';
  const dataKey = `plugin_${pluginName}`;
  let settings = {};
  let $pluginContainer = null;
  let plugin;
  const inputValues = {};
  let runkeeperPlugin;

  const syncDobMonthSelect = () => {
    syncReskinSelect($pluginContainer.find(`${settings.selectors.dobDatePicker} .date-picker__month`));
  };

  /**
   * We do some hacky stuff to restore unsaved values because we're very helpful, so we need to tell the date of birth
   * date picker to re-populate itself when that happens. It first tries to see if we have dob stored and uses that
   * instead of whatever gets passed into the parameter.
   * @param dob
   */
  const fixDateOfBirth = (dob = null) => {
    const $datePicker = $pluginContainer.find(settings.selectors.dobDatePicker);

    if (!$datePicker.length) {
      return;
    }

    if (dob === false) {
      $datePicker.datePicker('clearDate');
      syncDobMonthSelect();
      return;
    }

    const theDob = inputValues['registrant[dob]'] || dob;

    if ($datePicker.length && typeof theDob === 'string') {
      $datePicker.datePicker('setDate', moment(theDob));
      syncDobMonthSelect();
    }
  };

  /**
   * If we aren't restricting countries, just return true
   * If we are, return whether the given country is in our allowed countries list
   * @param country
   * @returns {boolean}
   */
  const isCountryValid = (country) => {
    if (!window.RR.restrictedCountries || !window.RR.restrictedCountries.length) {
      return true;
    }

    return window.RR.restrictedCountries.includes(country);
  };

  /**
   * Sub-event country allow-list from the personal-info container. Empty = no restriction.
   * @param country
   * @returns {boolean}
   */
  const isSubEventCountryValid = (country) => {
    let allowedCountries = [];
    try {
      allowedCountries = JSON.parse(
        $pluginContainer
          .find(settings.selectors.personalInformationContainer)
          .first()
          .attr('data-js-sub-event-allowed-countries') || '[]',
      );
    } catch {
      allowedCountries = [];
    }

    return !allowedCountries.length || (country && allowedCountries.includes(country));
  };

  /**
   * Toggle the field-level "Country not valid" error for sub-event restrictions.
   * @param $country
   * @param show
   */
  const setSubEventCountryError = ($country, show) => {
    if (!$country || !$country.length) {
      return;
    }

    const $container = $country.closest('.form-group').length
      ? $country.closest('.form-group')
      : $country.parent();

    $container.find('.help-block.js-sub-event-country-error').remove();
    $container.toggleClass('has-error clearfix', show);

    if (show) {
      $container.append(
        `<p class="help-block js-sub-event-country-error">${settings.i18n.countryNotValid}</p>`,
      );
    }
  };

  /**
   * If we aren't restricting subdivisions, just return true
   * If we are, return whether the given subdivision is in our allowed subdivisions list
   * @param subdivision
   * @returns {boolean}
   */
  const isSubDivisionValid = (subdivision) => {
    if (!window.RR.restrictedSubDivisions || !window.RR.restrictedSubDivisions.length) {
      return true;
    }

    return window.RR.restrictedSubDivisions.includes(subdivision);
  };

  /**
   * Validates country against event-level restrictions (modal) and sub-event allow-lists (field error).
   * @param $country
   * @returns {boolean}
   */
  const validateCountry = ($country) => {
    const country = $country.val();

    setSubEventCountryError($country, false);

    // user hasn't picked a country yet — required attribute / continue check handle empty
    if (!country) {
      return true;
    }

    if (!isCountryValid(country)) {
      $('#country-restriction-modal').modal('show');
      $country.val('');
      return false;
    }

    if (!isSubEventCountryValid(country)) {
      setSubEventCountryError($country, true);
      return false;
    }

    return true;
  };

  /**
   * Validates if registrant has subdivision restrictions and shows the modal if not
   * @param $subdivision
   * @returns {boolean}
   */
  const validateSubDivision = ($subdivision) => {
    const subdivision = $subdivision.val();

    // user hasn't picked a subdivision yet
    if (!subdivision) {
      return true;
    }

    if (!isSubDivisionValid(subdivision)) {
      $('#subdivision-restriction-modal').modal('show');
      $subdivision.val('');
      return false;
    }

    return true;
  };

  /**
   * Gimme the registrant's personal fields
   * @param registrant
   * @returns {{}}
   */
  const mapRegistrantPersonalFields = (registrant) => ({
    first_name: registrant.person.givenName,
    additional_name: registrant.person.additionalName,
    last_name: registrant.person.familyName,
    email: registrant.contactInformation.emailAddress,
    confirm_email: registrant.contactInformation.emailAddress,
    phone: registrant.contactInformation.phoneNumber,
    gender: registrant.person.sexCode,
    dob: registrant.person.dateOfBirth !== null
      ? moment.utc(registrant.person.dateOfBirth).format('YYYY-MM-DD')
      : null,
  });

  /**
   * Gimme the registrant's address fields
   * @param registrant
   * @returns {{}}
   */
  const mapRegistrantAddressFields = (registrant) => ({
    address: registrant.address.address,
    address_line_two: registrant.address.lineTwo,
    city: registrant.address.city,
    country: registrant.address.countryCode,
    subdivision: registrant.address.subdivision,
    postal_code: registrant.address.postalCode,
    latitude: registrant.address.latitude,
    longitude: registrant.address.longitude,
  });

  /**
   * Gimme all of the registrant's fields
   * @param registrant
   * @returns {{}}
   */
  const mapRegistrantFields = (registrant) => ({
    ...mapRegistrantPersonalFields(registrant),
    ...mapRegistrantAddressFields(registrant),
  });

  /**
   * If the server has information on the current registrant for the purpose of auto-population of personal
   * information (currently it checks if the date of birth exists, since that is always a mandatory field)
   * @returns {boolean}
   */
  const currentRegistrantExists = () => settings.registrantPersonalInformation.person.dateOfBirth !== null;

  /**
   * If they're regging themselves, try filling their stuff in
   * If they're regging someone else, clear all the things and try suggesting previously registered users
   */
  const toggleIsAdditional = (event) => {
    const selectedMyself = $(event.currentTarget).is(settings.selectors.registerMyself);
    const $suggestedRegistrants = $pluginContainer.find(settings.selectors.suggestedRegistrantContainer);

    if (selectedMyself) {
      $suggestedRegistrants.addClass('hidden');
      $suggestedRegistrants.find(settings.selectors.suggestedRegistrant).val('');

      if (!currentRegistrantExists()) {
        plugin.populate(mapRegistrantFields(settings.accountPersonalInformation));
      }
    } else {
      $suggestedRegistrants.removeClass('hidden');

      if (!currentRegistrantExists()) {
        plugin.clear();
      }
    }
  };

  /**
   * Builds up the suggested registrants select from the array given to us by the server
   */
  const loadRegistrants = () => {
    const suggestedRegistrantsArray = settings.suggestedRegistrantsPersonalInformation;
    const $suggestedRegistrantSelect = $pluginContainer.find(settings.selectors.suggestedRegistrant);

    const suggestedRegistrantOptions = suggestedRegistrantsArray.reduce((html, item, index) => `
            ${html}
            <option value="${index}">${$('<span/>').text(item.person.fullName).html()}</option>
        `, '');

    $suggestedRegistrantSelect.append(suggestedRegistrantOptions);
  };

  /**
   * If they pick a suggested registrant, fill their stuff in
   */
  const updateSuggestedRegistrant = function updateSuggestedRegistrant() {
    const registrantId = $(this).val();

    if (registrantId) {
      plugin.populate(mapRegistrantFields(settings.suggestedRegistrantsPersonalInformation[registrantId]));
    } else {
      plugin.clear();
    }
  };

  /**
   * If they pick a registrant from elsewhere in the registration, fill their address in
   */
  const copyRegistrantAddress = function copyRegistrantAddress() {
    const registrantId = $(this).val();

    if (registrantId) {
      plugin.populate(mapRegistrantAddressFields(settings.registrantsPersonalInformation[registrantId]));
    }
  };

  /**
   * Check the entered email and make suggestions based on whether we think they made a typo
   */
  const mailcheckSuggestion = function mailcheckSuggestion() {
    const $email = $(this);

    $.fn.MailcheckSuggestion({
      $emailInputContainer: $email.closest(settings.selectors.inputContainers),
      $emailInputField: $email,
      i18n: {
        emailSuggestionMessage: settings.i18n.emailSuggestionMessage,
      },
    });
  };

  /**
   * If a user touches an input, it's dirty, and we no longer want anything to do with it (but really, we don't want
   * to blow out the manually entered information when we do helpful things like fill in their information)
   *
   * @param $input
   */
  const markInputAsDirty = function markInputAsDirty($input) {
    $input.addClass(settings.selectors.dirtyInput.substring(1));

    if ($input.hasClass('date-picker__form-control')) {
      $input.closest('.date-picker').find('.date-picker__combined').addClass('dirty');
    }
  };

  /**
   * Save all input values to data-value so we can restore them later if needed
   */
  const storeInputValue = function storeInputValue() {
    const $this = $(this);
    // sometimes the input doesn't have an id
    const selector = $this.attr('id') || $this.attr('name');
    let value;

    if ($this.is(':checked')) {
      value = 'checked';

      // if it's a radio field, we need to remove all radios of the same name from the stored input values (but
      // then we'll add the freshly checked one back in after)
      if ($this.is(':radio')) {
        $pluginContainer.find(`[name="${$this.attr('name')}"]`).each((index, radio) => {
          delete inputValues[$(radio).attr('id')];
        });
      }
    } else {
      value = $this.val() || '';
    }

    inputValues[selector] = value;
  };

  /**
   * Return the maximum minimum age between the registrant's country and the event's country (if registrant's
   * country's minimum age is 13 and event's country's minimum age is 15, return 15). If we don't have a minimum age
   * for either country, just return the default (probably 18) to be safe.
   * @returns {int}
   */
  const getMinimumRequiredAge = () => {
    const registrantCountry = $pluginContainer.find(settings.selectors.country).val();
    const registrantMinimumAge = (registrantCountry && registrantCountry in settings.ageMinimums)
      ? settings.ageMinimums[registrantCountry]
      : 0;
    const eventMinimumAge = (settings.eventCountry in settings.ageMinimums)
      ? settings.ageMinimums[settings.eventCountry]
      : 0;
    const minimumAge = (registrantMinimumAge > eventMinimumAge)
      ? registrantMinimumAge
      : eventMinimumAge;

    return minimumAge || settings.ageMinimumDefault;
  };

  /**
   * Toggles the display of the shipping information
   */
  const toggleShippingInformation = () => {
    $(settings.selectors.shippingInformationContainer).toggleClass(
      'hidden',
      !$(settings.selectors.collectShippingAddress).is(':checked'),
    );
  };

  /**
   * Toggle the display of the Runkeeper integration
   */
  const toggleRunkeeperIntegration = () => {
    if (!runkeeperPlugin) {
      return;
    }

    const isMyself = $pluginContainer.find(settings.selectors.registerMyself).is(':checked');

    runkeeperPlugin.toggle(isMyself);
  };

  /**
   * Tells the registration questions plugin to toggle the opt in questions (show if myself is
   * selected, hide otherwise)
   */
  const toggleOptInQuestions = () => {
    if (!settings.registrationQuestionsPlugin) {
      return;
    }

    const isMyself = $pluginContainer.find(settings.selectors.registerMyself).is(':checked');

    settings.registrationQuestionsPlugin.toggleOptInQuestions(isMyself);
  };

  /**
   * Tells the registration questions whether the user selected "Myself" and their country
   */
  const toggleGeographicallyLimitedQuestions = () => {
    if (!settings.registrationQuestionsPlugin) {
      return;
    }

    if (!$pluginContainer.find(settings.selectors.registerMyself).is(':checked')) {
      settings.registrationQuestionsPlugin.toggleGeographicallyLimitedQuestions(false);
      return;
    }

    const $country = $pluginContainer.find(settings.selectors.country);

    if (!$country.length) {
      settings.registrationQuestionsPlugin.toggleGeographicallyLimitedQuestions(false);
      return;
    }

    const country = $country.val();

    if (!country) {
      settings.registrationQuestionsPlugin.toggleGeographicallyLimitedQuestions(false);
      return;
    }

    settings.registrationQuestionsPlugin.toggleGeographicallyLimitedQuestions(true, country);
  };

  /**
   * Initialize the Runkeeper integration
   */
  const initializeRunkeeperIntegration = () => {
    // Reset the plugin
    runkeeperPlugin = null;

    // If the container isn't there, we can ignore this integration for the moment
    if (!$pluginContainer.find(settings.selectors.runkeeper).length) {
      return;
    }

    runkeeperPlugin = $pluginContainer.find(settings.selectors.runkeeper).runkeeperPlugin();

    // Pre-select the "myself" option if they have connected themselves to Runkeeper
    if (runkeeperPlugin.isConnected()) {
      $pluginContainer.find(settings.selectors.registerMyself).prop('checked', true).trigger('change');
    }

    // Toggle the Runkeeper integration
    toggleRunkeeperIntegration();
  };

  /**
   * Sets up date picker for date of birth
   * @param subEventId
   */
  const setupDatePicker = (subEventId) => {
    const $dateOfBirth = $pluginContainer.find(settings.selectors.dobDatePicker);

    // if reg isn't tracking date of birth don't bother
    if (!$dateOfBirth.length) {
      return;
    }

    // if the sub-event doesn't care about age, just set the user's minimum age to now
    if (!settings.subEventAgeLimits[subEventId]) {
      $dateOfBirth.datePicker({
        maxDate: moment(),
      });
      return;
    }

    // ageLimits will be an object with optional either/both max and min ages, and a calculationDate
    // calculation date is defined in sub-event settings and can be 1 of 3 things:
    // 1) event date (default) - limit person's age based on how old they will be on event date
    // 2) today - limit person's age based on how old they are today
    // 3) custom arbitrary date set by a date picker
    const ageLimits = settings.subEventAgeLimits[subEventId];

    $dateOfBirth
      .datePicker({
        minDate: ageLimits.maximumAge
          // basically what we're doing here is ensuring that a person who is e.g. 9 years + 364
          // days old can still register for an event that has a max age of 9 years (because they
          // technically aren't 10 until tomorrow)
          ? moment(ageLimits.calculationDate)
            .subtract(ageLimits.maximumAge, 'years')
            .subtract(1, 'years')
            .add(1, 'days')
          : undefined,
        // this one's a little easier to calculate
        maxDate: ageLimits.minimumAge
          ? moment(ageLimits.calculationDate).subtract(ageLimits.minimumAge, 'years')
          : moment(),
        errors: {
          minDate: ageLimits.maximumAge
            ? settings.i18n.ageLimit
            : undefined,
          maxDate: ageLimits.minimumAge
            ? settings.i18n.ageLimit
            : undefined,
        },
      });
  };

  /**
   * Initialize intl-tel-input on personal-info phone fields (same control as registration questions)
   */
  const setupPhoneNumberInputs = () => {
    if (typeof window.intlTelInput !== 'function') {
      return;
    }

    const eventCountryCode = (settings.eventCountry || 'us').toLowerCase();

    $pluginContainer.find('[data-format-phone-number]').each((key, element) => {
      const existing = window.intlTelInput.getInstance?.(element);

      if (existing) {
        existing.destroy();
      }

      window.intlTelInput(element, {
        separateDialCode: true,
        countryOrder: ['us', 'ca', 'gb', 'au'],
        initialCountry: eventCountryCode,
      });
    });
  };

  /**
   * Re-apply reskin Select2 after geography rebuilds country/subdivision options.
   * Geography destroys Select2 on country change and only re-inits when data-js-select2 is truthy,
   * but it blanks that attribute during destroy, so we re-init here.
   */
  const initializeAddressSelects = () => {
    const $subdivisionSelect = $pluginContainer.find(settings.selectors.subdivisionSelect);

    $subdivisionSelect.filter('.d-none').each((index, element) => {
      destroyReskinSelect($(element));
    });

    initializeReskinSelects(
      $pluginContainer.find(settings.selectors.country).add($subdivisionSelect.not('.d-none'))
    );
  };

  /**
   * Geography hides the subdivision select for countries without subdivisions but leaves the
   * last dropdown value in the text field. Clear it on a native country change only — setAddress
   * (copy-address / suggested registrant / autocomplete) does not fire change.
   *
   * @param $country
   */
  const clearHiddenSubdivisionText = ($country) => {
    const $container = $country.closest(
      `${settings.selectors.personalInformationContainer}, ${settings.selectors.shippingInformationContainer}`
    );
    const $subdivisionSelect = $container.find(
      `${settings.selectors.subdivisionSelect}, [data-js-geography-subdivision-select]`
    );
    const $subdivisionText = $container.find(
      `${settings.selectors.subdivisionText}, [data-js-geography-subdivision-text]`
    );

    if ($subdivisionSelect.hasClass('d-none')) {
      $subdivisionText.val('');
    }
  };

  /**
   * Initialize the geography plugin on the personal information form and the shipping form. The
   * geography plugin will skip setting up Google Autocomplete if the Google Maps API isn't present
   */
  const setupGeography = () => {
    const $personalInformationContainer = $pluginContainer
      .find(settings.selectors.personalInformationContainer);
    const $shippingInformationContainer = $pluginContainer
      .find(settings.selectors.shippingInformationContainer);
    const $snackBar = $('.snack-bar');

    $personalInformationContainer.geography({
      autocompleteService: settings.autocompleteService,
      callbacks: {
        // hooking into the autocompleteInitialized event rather than plugging `settings.autocompleteService` directly
        // into the metrics in case we're in a locale for which we disabled autocomplete (or whatever other reason the
        // chosen service isn't available)
        autocompleteInitialized: ($element, data, autocompleteService) => {
          plugin.metrics.autocompleteService = autocompleteService;
        },
        streetAddressLacksNumber: () => {
          $snackBar.snackBar('add', {
            type: 'danger',
            content: settings.i18n.googleAutocompleteIncomplete,
          });
        },
        locationFieldsUpdated: () => {
          // validate the country first - if it's invalid, don't continue (prevents double modals)
          if (!validateCountry($personalInformationContainer.find(settings.selectors.country))) {
            return;
          }

          validateSubDivision($personalInformationContainer.find(settings.selectors.subdivisionSelect));
        },
        placeSelected: ($element, data, place, searchString) => {
          plugin.metrics.autocompleteSelectedPlace = true;
          plugin.metrics.autocompleteQueryLength = searchString.length;
        },
        selectedPlaceManuallyModified: ($element, data, affectedInput) => {
          plugin.metrics.autocompleteModifiedFieldsAfterPlaceSelection.push(affectedInput.id);
        },
      },
    });

    if ($shippingInformationContainer.length) {
      $shippingInformationContainer.geography({
        autocompleteService: settings.autocompleteService,
        callbacks: {
          streetAddressLacksNumber: () => {
            $snackBar.snackBar('add', {
              type: 'danger',
              content: settings.i18n.googleAutocompleteIncomplete,
            });
          },
          placeSelected: ($element, data, place, searchString) => {
            plugin.metrics.autocompleteShippingSelectedPlace = true;
            plugin.metrics.autocompleteShippingQueryLength = searchString.length;
          },
          selectedPlaceManuallyModified: ($element, data, affectedInput) => {
            plugin.metrics.autocompleteShippingModifiedFieldsAfterPlaceSelection.push(affectedInput.id);
          },
        },
      });
    }
  };

  /**
   * Initialize the plugin
   * @private
   */
  const initialize = function initialize() {
    $pluginContainer.on('change', settings.selectors.inputs, storeInputValue);
    $pluginContainer.on('change', settings.selectors.isAdditional, (event) => {
      toggleIsAdditional(event);
      toggleRunkeeperIntegration(event);
      toggleOptInQuestions(event);
      toggleGeographicallyLimitedQuestions();
    });
    $pluginContainer.on('change', settings.selectors.suggestedRegistrant, updateSuggestedRegistrant);
    $pluginContainer.on('change', settings.selectors.copyAddress, copyRegistrantAddress);
    $pluginContainer.on('blur', settings.selectors.email, mailcheckSuggestion);
    $pluginContainer.on('keyup', settings.selectors.inputs, () => markInputAsDirty($(this)));
    $pluginContainer.on('change', settings.selectors.collectShippingAddress, toggleShippingInformation);
    $pluginContainer.on(
      'change',
      `${settings.selectors.country}, ${settings.selectors.shippingCountry}`,
      (event) => {
        clearHiddenSubdivisionText($(event.target));
      }
    );
    $pluginContainer.on('change blur', settings.selectors.country, (event) => {
      if (validateCountry($(event.target))) {
        if (event.type === 'change') {
          toggleGeographicallyLimitedQuestions();
        }
      }
    });
    $pluginContainer.on('change', settings.selectors.subdivisionSelect, (event) => {
      validateSubDivision($(event.target));
    });

    $pluginContainer.on(`change ${pluginName}.fieldPopulated`, settings.selectors.givenName, (event, value) => {
      settings.callbacks.onGivenNameChange(value || event.target.value);
    });

    $pluginContainer.on(`change ${pluginName}.fieldPopulated`, settings.selectors.familyName, (event, value) => {
      settings.callbacks.onFamilyNameChange(value || event.target.value);
    });

    $pluginContainer.on('raceRoster.datePicker.dateSet', settings.selectors.dobDatePicker, () => {
      syncDobMonthSelect();

      const dateOfBirth = $pluginContainer.find(settings.selectors.dobDatePicker).datePicker('getDate');

      if (dateOfBirth) {
        settings.callbacks.onDateOfBirthChange(dateOfBirth.format('YYYY-MM-DD'));
      }
    });

    $pluginContainer.on(`change ${pluginName}.fieldPopulated`, settings.selectors.isAdditional, (event, value) => {
      settings.callbacks.onProvidedForChange(value || event.target.value);
    });

    $pluginContainer
      .on(`change ${pluginName}.fieldPopulated`, settings.selectors.suggestedRegistrant, (event, value) => {
        settings.callbacks.onSuggestedRegistrantChange(value || event.target.value);
      });

    $pluginContainer
      .on('raceRoster.geography.locationFieldsUpdated', settings.selectors.personalInformationContainer, (event) => {
        initializeAddressSelects();

        if (validateCountry($(event.target))) {
          toggleGeographicallyLimitedQuestions();
        }
      });

    $(window).on('pageshow', (event) => {
      // there's a chrome bug around the persisted property so we check window.performance too
      if (event.originalEvent.persisted || (window.performance && window.performance.navigation.type === 2)) {
        plugin.populate();

        if (!settings.registrationQuestionsPlugin) {
          return;
        }

        toggleOptInQuestions();

        // if the registration questions plugin hasn't loaded by the time we call `toggleOptInQuestions`, we'll wait
        // until it loads and call it again
        settings.registrationQuestionsPlugin.element.on('registrationQuestionsPlugin.contentDisplayed', () => {
          toggleOptInQuestions();
        });
      }
    });
  };

  /**
   * @param element
   * @param options
   * @constructor
   */
  const Plugin = function Plugin(element, options) {
    plugin = this;
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      registrationQuestionsPlugin: null,
      registrationUrl: null,
      registrantIndex: 1,
      hasCustomSubEventRequiredFields: false,
      eventRequiredFields: {},
      subEventRequiredFields: {},
      i18n: {},
      accountPersonalInformation: null,
      suggestedRegistrantsPersonalInformation: {},
      registrantPersonalInformation: null,
      registrantsPersonalInformation: null,
      ageMinimumDefault: null,
      ageMinimums: {},
      subEventAgeLimits: null,
      language: 'en',
      languageRegion: 'US',
      autocompleteService: 'google',
      callbacks: {
        onGivenNameChange: () => {},
        onFamilyNameChange: () => {},
        onDateOfBirthChange: () => {},
        onProvidedForChange: () => {},
        onSuggestedRegistrantChange: () => {},
      },
      selectors: {
        personalInformationContainer: '.js-personal-information-container',
        inputContainers: '.js-registrant-information-input-container',
        inputs: ':input[name^="registrant["],.date-picker__form-control',
        required: '.js-required',
        dirtyInput: '.dirty',
        isAdditional: '.js-is-additional',
        registerMyself: '.js-register-myself',
        registerSomeoneElse: '.js-register-someone-else',
        suggestedRegistrantContainer: '.js-suggested-registrant-container',
        suggestedRegistrant: '.js-suggested-registrant',
        givenName: '[data-js-given-name]',
        familyName: '[data-js-family-name]',
        dob: '.js-dob',
        dobDatePicker: '.js-dob-date-picker',
        email: '.js-email',
        copyAddress: '.js-copy-address',
        address: '.js-address',
        addressLineTwo: '.js-address-line-two',
        latitude: '[data-js-latitude]',
        longitude: '[data-js-longitude]',
        city: '.js-city',
        subdivision: '.js-subdivision',
        subdivisionText: '[data-js-subdivision-text]',
        subdivisionSelect: '[data-js-subdivision-select]',
        postalCode: '.js-postal',
        country: '.js-country',
        collectShippingAddress: '.js-collect-shipping-address',
        shippingInformationContainer: '.js-shipping-information-container',
        shippingLineOne: '.js-shipping-line-one',
        shippingLineTwo: '.js-shipping-line-two',
        shippingCity: '.js-shipping-city',
        shippingSubdivision: '.js-shipping-subdivision',
        shippingPostalCode: '.js-shipping-postal',
        shippingCountry: '.js-shipping-country',
        runkeeper: '[data-js-runkeeper-container]',
      },
    };
    this.metrics = {
      autocompleteService: null,
      autocompleteSelectedPlace: false,
      autocompleteQueryLength: null,
      autocompleteModifiedFieldsAfterPlaceSelection: [],
      autocompleteShippingSelectedPlace: false,
      autocompleteShippingQueryLength: null,
      autocompleteShippingModifiedFieldsAfterPlaceSelection: [],
    };
    settings = $.extend(this.settings, options);
    $pluginContainer = element;

    initialize();
  };

  /**
   * Initialize the functional components of the content
   * @param subEventId
   */
  Plugin.prototype.initializeContent = (subEventId) => {
    loadRegistrants();
    setupGeography();
    setupDatePicker(subEventId);
    setupPhoneNumberInputs();

    plugin.populate();
    initializeReskinSelects($pluginContainer.find('select.form-control'));

    // After re-rendering the form, we should re-populate the information based on the selected `is_additional`
    $pluginContainer.find(settings.selectors.isAdditional).filter(':checked').trigger('change');

    // Trigger the change event for shipping information toggle
    $pluginContainer.find(settings.selectors.collectShippingAddress).trigger('change');

    initializeRunkeeperIntegration();
  };

  /**
   * Display the plugin's contents
   * @param content
   * @param subEventId
   */
  Plugin.prototype.displayContent = (content, subEventId) => {
    if (content) {
      $pluginContainer.html(content);
    }

    plugin.initializeContent(subEventId);
  };

  /**
   * Populate participant form with data provided in user object (except fields they already filled in manually). It
   * first tries to see if we have data stored for a particular field and uses that instead of whatever gets passed
   * into the user object.
   *
   * @access public
   * @param user
   */
  Plugin.prototype.populate = (user = null) => {
    const geographyFieldSelector = [
      settings.selectors.country,
      settings.selectors.subdivision,
      settings.selectors.subdivisionSelect,
      settings.selectors.subdivisionText,
    ].join(',');
    const isBlank = (candidate) => candidate === undefined || candidate === null || candidate === '';

    $pluginContainer.find(settings.selectors.inputs).not(settings.selectors.dirtyInput).each((index, field) => {
      const $field = $(field);

      // Don't attempt to populate a field that was marked dirty that may not exist on this sub-event
      if (!$field.length) {
        return;
      }

      // geography('setAddress') owns country/subdivision order when copying or suggesting an address
      if (user && $field.is(geographyFieldSelector)) {
        return;
      }

      // if we have a value stored grab that first
      let value = [inputValues[$field.attr('id')], inputValues[$field.attr('name')]]
        .find((candidate) => !isBlank(candidate));

      // Ensure that the value we're populating will still be marked as dirty
      // After re-rendering the form, the dirty flags were cleared
      if (!isBlank(value)) {
        markInputAsDirty($field);
      }

      // if not, try to find it in the user
      if (isBlank(value) && user) {
        value = [user[$field.attr('id')], user[$field.attr('name')]]
          .find((candidate) => !isBlank(candidate));
      }

      // if we still don't have it, give up and move onto the next field
      if (isBlank(value)) {
        return;
      }

      if (value === 'checked') {
        if (!$field.is(':checked')) {
          $field.prop('checked', true);
        }
      } else if ($field.is('[data-format-phone-number]')) {
        const phoneNumber = window.intlTelInput?.getInstance?.(field);

        if (phoneNumber) {
          phoneNumber.setNumber(value);
        } else {
          $field.val(value);
        }
      } else {
        $field.val(value);

        if ($field.is('select')) {
          syncReskinSelect($field);
        }
      }

      $field.trigger(`${pluginName}.fieldPopulated`, [value]);
    });

    // now that that's over with, we need to fix address date of birth because they get real DOM-y
    if (user) {
      $pluginContainer
        .find(settings.selectors.personalInformationContainer)
        .geography('setAddress', {
          countryCode: user.country,
          subdivisionCode: user.subdivision,
          city: user.city,
          streetAddress: user.address,
          postalCode: user.postal_code,
        });

      const dirtyDobFields = $pluginContainer.find('.date-picker__form-control.dirty').length;

      // we only want to change the dob if the user hasn't touched it
      if (dirtyDobFields === 0) {
        fixDateOfBirth(user.dob);
      }
    } else {
      // things might be weird here due to circular population between the inputs and the values we later store
      // when the user changes stuff. but the triggering of the change event on one date picker field should
      // update the combined date field for us. and we could all be happy. maybe.
      const $datePickerMonth = $pluginContainer.find('.date-picker__month');

      if ($datePickerMonth.val()) {
        $datePickerMonth.trigger('change');
      } else {
        $pluginContainer.find('.date-picker').datePicker('clearDate');
      }

      // Restore path only: rebuild subdivision options for the stored country, then re-apply subdivision
      const $countryField = $pluginContainer.find(settings.selectors.country);
      const $subdivisionSelect = $pluginContainer.find(settings.selectors.subdivisionSelect);

      if ($countryField.val()) {
        const restoredSubdivision = $subdivisionSelect.val()
          || inputValues[$subdivisionSelect.attr('id')]
          || inputValues[$subdivisionSelect.attr('name')];

        $countryField.trigger('change');

        if (restoredSubdivision) {
          $subdivisionSelect.val(restoredSubdivision);
        }

        initializeAddressSelects();
      }
    }
  };

  /**
   * Clear participant information (except fields they already filled in manually)
   *
   * @access public
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.find(settings.selectors.inputs)
      .not(`${settings.selectors.dirtyInput},${settings.selectors.isAdditional}`)
      .val('');
    $pluginContainer
      .find(settings.selectors.personalInformationContainer)
      .geography('clearAddress');
    fixDateOfBirth(false);
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  /**
   * Check that the registrant's age meets the minimum requirements (but if they indicated that they are registering
   * someone else or if we don't even have a date of birth field, just return true)
   * @returns {boolean}
   */
  Plugin.prototype.checkAge = () => {
    if ($pluginContainer.find(settings.selectors.registerSomeoneElse).is(':checked')) {
      return true;
    }

    const $dateOfBirth = $pluginContainer.find(settings.selectors.dob);

    if ($dateOfBirth.length === 0) {
      return true;
    }

    const dateOfBirthValue = $dateOfBirth.val();

    if (!dateOfBirthValue) {
      return true;
    }

    const dateOfBirth = moment.utc(dateOfBirthValue, 'YYYY-MM-DD');
    const years = dateOfBirth.isValid() ? moment().diff(dateOfBirth, 'years') : 0;
    return years >= getMinimumRequiredAge();
  };

  /**
   * Enforce sub-event country allow-list before continue. Shows a snackbar on failure.
   * @returns {boolean}
   */
  Plugin.prototype.checkSubEventCountry = () => {
    const $country = $pluginContainer.find(settings.selectors.country);
    if (!$country.length || isSubEventCountryValid($country.val())) {
      setSubEventCountryError($country, false);
      return true;
    }

    setSubEventCountryError($country, true);
    $('.snack-bar, [data-js-snack-bar]').first().snackBar('add', {
      type: 'danger',
      icon: 'exclamation-circle',
      content: settings.i18n.participantCountryNotValidForSubEvent,
    });

    if ($country.is(':visible')) {
      $country.trigger('focus');
    }

    return false;
  };

  /**
   * Did the register indicate that "Myself" is registering?
   * @returns {boolean}
   */
  Plugin.prototype.getProvidedFor = () => $pluginContainer
    .find(settings.selectors.isAdditional)
    .filter(':checked')
    .val();

  /**
   * Get the registrant's given name
   * @returns {string}
   */
  Plugin.prototype.getGivenName = () => $pluginContainer
    .find(settings.selectors.givenName)
    .val()
    ?.trim();

  /**
   * Get the registrant's family name
   * @returns {string}
   */
  Plugin.prototype.getFamilyName = () => $pluginContainer
    .find(settings.selectors.familyName)
    .val()
    ?.trim();

  /**
   * Get the registrant's date of birth
   * @returns {string}
   */
  Plugin.prototype.getDateOfBirth = () => $pluginContainer.find(settings.selectors.dob).val();

  /**
   * Get the registrant's selected country
   * @returns {string}
   */
  Plugin.prototype.getSelectedCountry = () => $pluginContainer.find(settings.selectors.country).val();

  /**
   * Serialize personal information, converting intl-tel inputs to E.164
   * @returns {string}
   */
  Plugin.prototype.serialize = () => {
    const data = $pluginContainer.serializeArray();

    const formattedData = data.map((field) => {
      const $element = $pluginContainer.find(`[name="${field.name}"]`);

      if ($element.is('[data-format-phone-number]')) {
        const phoneNumber = window.intlTelInput?.getInstance?.($element[0]);

        if (phoneNumber) {
          field.value = phoneNumber.getNumber();
        }
      }

      return field;
    });

    return $.param(formattedData);
  };

  /**
   * Get the metrics for this plugin
   * @returns {*}
   */
  Plugin.prototype.getMetrics = () => plugin.metrics;

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
